import cachedBase from './cachedBase';

export default cachedBase;
